<template>
  <b-card no-body class="mb-1" style="margin: 20px">
    <b-card-header
      header-tag="header"
      class="p-1"
      role="tab"
      style="background: #c93962; font-size 24px; color: white"
    >
      <!-- <b-button block href="#" class="filtro-button" v-b-toggle.filtro variant="info">Filtros</b-button> -->
      <div class="row" style="padding-top: 5px; padding-bottom: 5px">
        <div class="col-6">
          <div style="margin-left: 20px; margin-top: 12px;">Filtros</div>
        </div>
        <div class="col-6 text-right">
          <!-- <span
            style="cursor: pointer; font-size: 30px; font-wight: bold"
            v-b-toggle.filtro
            @click="clicked"
          >+</span> -->
           <div 
            style="cursor: pointer; font-size: 30px; font-wight: bold" v-b-toggle.filtro
            @click="clicked"
          >
          <span v-if="visible">-</span>
          <span v-else>+</span>
          </div>
        </div>
      </div>
    </b-card-header>
    <b-collapse id="filtro" visible accordion="my-accordion" role="tabpanel" :class="visible ? 'show' : ''" :style=" visible ? '' : 'display: none;' ">
      <b-card-body>
        <slot></slot>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      visible: true
    };
  },
  methods: {
    clicked() {
        this.visible = !this.visible;
    }
  }
};
</script>